import React, { useState } from 'react'
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { userloginDetails } from '../Utils/AdminAuth';
import Axios from '../../axios/Axios';
import { NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import DeleteModal from '../Dashboard/campaign/Rcs/DeleteModal';

const DeleteBouncedList = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const userType = lStorage?.user?.isAdmin;

    const [email, setEmail] = useState('');
    const [emailList, setEmailList] = useState([]);
    const [error, setError] = useState({
        status: false,
        bgColor: "",
        message: ""
    });
    const [showDelete, setShowDelete] = useState(false);
    const [deleteEmail, setDeleteEmail] = useState("");

    const onSearch = async () => {
        let paramData = {
            user_id: userId,
            method: "listBounced",
            email: email,
            user_type: userType
        };

        try {
            const { data } = await Axios.post(
                `${NODE_HOST_URL_v1}/admin/Bounced`,
                paramData,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`
                    }
                }
            );
            if (data.success) {
                setEmailList(data.data);
                setEmail("");
            }
            else {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    message: data.message
                })
            }
        } catch (error) {
             setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    message: error.response?.data?.message || "Something went wrong, please try again later"
                })
        }
    };

    const ShowDelete = (email) => {
        setShowDelete(true);
        setDeleteEmail(email);
    }

    const ClosePopup = () => {
        setShowDelete(false);
    }

    const DeleteBounceList = async () => {
        let paramData = {
            user_id: userId,
            method: "deleteBounced",
            email: deleteEmail,
            user_type: userType
        };

        try {
            const { data } = await Axios.post(
                `${NODE_HOST_URL_v1}/admin/Bounced`,
                paramData,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`
                    }
                }
            );
            if (data.success) {
                setError({
                    status: true,
                    bgColor: "alert alert-success",
                    message: data.message
                })
                setShowDelete(false)
            }
            else {
                setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    message: data.message
                })
            }
        } catch (error) {
            setError({
                    status: true,
                    bgColor: "alert alert-danger",
                    message: error.response?.data?.message || "Something went wrong, please try again later"
                })
        }
    }

    return (
        <div className="wrapper">
            <AdminLeftMenu />
            <div className="main">
                <AdminHeader />
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="row mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3>
                                    <strong> Delete </strong> Bounced List{" "}
                                </h3>
                            </div>
                        </div>
                        {error.status ? (
                            <div className={error.bgColor} role="alert">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="alert"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                                <div className="">{error.message}</div>
                            </div>
                        ) : null}

                        <div className='row'>
                            <div className='col-5'>
                                <input type='text' className='form-control' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Enter Email' />
                            </div>

                            <div className='col-3'>
                                <button type="button" onClick={onSearch} class="btn btn-info">Search</button>
                            </div>
                        </div>

                        {emailList.length > 0 &&
                            <div className='row mt-4'>
                                <div className='col-12'>
                                    <div className='table-responsive'>
                                        <table className='table table-bordered table-hover table-striped'>
                                            <thead className='table-dark'>
                                                <tr>
                                                    <th>Email</th>
                                                    <th>Created</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emailList.map((user) => (
                                                    <tr key={user.email}>
                                                        <td>{user.email}</td>
                                                        <td>{user.created}</td>
                                                        <td><FontAwesomeIcon style={{ cursor: "pointer" }} onClick={() => ShowDelete(user.email)} icon={faTrashAlt} /></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>}
                        <DeleteModal show={showDelete} onClose={ClosePopup} onDelete={DeleteBounceList} />

                    </div>
                </main>
                <AdminFooter />
            </div>
        </div>
    )
}

export default DeleteBouncedList
